<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-n3">Which of the molecules listed below is the <b>most</b> polar?</p>

      <v-radio-group v-model="inputs.mostPolar" :disabled="!allowEditing" class="pl-6 mb-n6">
        <v-radio
          v-for="option in options"
          :key="'pt-1-' + option.value"
          class="my-1"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import ChemicalLatex from '../displayers/ChemicalLatex';
import StembleLatex from '@/tasks/components/StembleLatex';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'uOttawa1321Prelab1Q2',
  components: {
    ChemicalLatex,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        mostPolar: null,
      },
      options: [
        {text: '$\\ce{H2O}$', value: 'H2O'},
        {text: '$\\ce{CH4}$', value: 'CH4'},
        {text: '$\\ce{HBr}$', value: 'HBr'},
        {text: '$\\ce{NH3}$', value: 'NH3'},
        {text: '$\\ce{HF}$', value: 'HF'},
      ],
    };
  },
  computed: {
    imageNumber() {
      return this.taskState.getValueBySymbol('imageNumber').content;
    },
    imageName() {
      return prefixPublicAsset('/img/assignments/Q1-TLC-V' + this.imageNumber.value + '.png');
    },
  },
};
</script>
